import { useState } from "react";
import { Menu, X, CalendarHeart } from "lucide-react";
import { Logo } from "./Logo";
import { DORIE_URL, NAV_LINKS } from "../constants";

export const Header = ({ onOpenCertificates }) => {
    const [open, setOpen] = useState(false);

    const renderLink = (link, isMobile) => {
        const cls = isMobile
            ? "rounded-xl px-4 py-3 text-base font-medium text-miam-dark transition-colors duration-300 hover:bg-miam-green/10 hover:text-miam-green text-right"
            : "text-sm font-medium text-miam-dark transition-colors duration-300 hover:text-miam-green";
        if (link.id === "certificates") {
            return (
                <button
                    key={link.id}
                    type="button"
                    data-testid={isMobile ? "mobile-nav-link-certificates" : "nav-link-certificates"}
                    onClick={() => {
                        setOpen(false);
                        onOpenCertificates();
                    }}
                    className={cls}
                >
                    {link.label}
                </button>
            );
        }
        return (
            <a
                key={link.id}
                href={`#${link.id}`}
                data-testid={`${isMobile ? "mobile-" : ""}nav-link-${link.id}`}
                onClick={isMobile ? () => setOpen(false) : undefined}
                className={cls}
            >
                {link.label}
            </a>
        );
    };

    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-40 bg-white/80 backdrop-blur-md border-b border-miam-green/10"
        >
            <div className="mx-auto max-w-7xl px-5 lg:px-10">
                <div className="flex h-20 items-center justify-between gap-4">
                    <Logo />

                    <nav
                        data-testid="desktop-nav"
                        className="hidden lg:flex items-center gap-8"
                        aria-label="التنقل الرئيسي"
                    >
                        {NAV_LINKS.map((link) => renderLink(link, false))}
                    </nav>

                    <div className="flex items-center gap-3">
                        <a
                            href={DORIE_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="header-booking-button"
                            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-miam-green px-6 py-2.5 text-sm font-bold text-white transition-[transform,background-color,box-shadow] duration-300 hover:-translate-y-0.5 hover:bg-miam-green-dark hover:shadow-lg"
                        >
                            <CalendarHeart className="h-4 w-4" aria-hidden="true" />
                            احجزي موعدك
                        </a>
                        <button
                            type="button"
                            data-testid="mobile-menu-toggle"
                            aria-label={open ? "إغلاق القائمة" : "فتح القائمة"}
                            aria-expanded={open}
                            onClick={() => setOpen(!open)}
                            className="lg:hidden inline-flex h-11 w-11 items-center justify-center rounded-full border border-miam-green/30 bg-miam-green/10 text-miam-dark shadow-sm transition-colors duration-300 hover:bg-miam-green/20"
                        >
                            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                        </button>
                    </div>
                </div>
            </div>

            {open && (
                <nav
                    data-testid="mobile-menu"
                    aria-label="قائمة الجوال"
                    className="lg:hidden border-t border-miam-green/10 bg-white/95 backdrop-blur-md"
                >
                    <div className="mx-auto max-w-7xl px-5 py-4 flex flex-col gap-1">
                        {NAV_LINKS.map((link) => renderLink(link, true))}
                        <a
                            href={DORIE_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="mobile-menu-booking-button"
                            className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-miam-green px-6 py-3 text-sm font-bold text-white transition-colors duration-300 hover:bg-miam-green-dark"
                        >
                            <CalendarHeart className="h-4 w-4" aria-hidden="true" />
                            احجزي موعدك
                        </a>
                    </div>
                </nav>
            )}
        </header>
    );
};
